<h3 style="text-align:center;font-size:1.77rem;font-weight:500">
    Documentos del trabajador
</h3>
<table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
        <!-- Spinner de carga -->
        <div *ngIf="loadingData" class="spinner-container">
            <mat-spinner diameter="50"></mat-spinner>
        </div>
    <ng-container matColumnDef="descripcion">
        <th mat-header-cell *matHeaderCellDef> DESCRIPCIÓN </th>
        <td mat-cell *matCellDef="let element"> {{ element.description }} </td>
    </ng-container>
    <ng-container matColumnDef="acciones">
        <th mat-header-cell *matHeaderCellDef> ACCIONES </th>
        <td mat-cell *matCellDef="let element">
            <p-button class="mr-2" icon="pi pi-download" (click)="DescargarDocumento(element.id)" styleClass="p-button-rounded p-button-primary p-button-text" ></p-button>
            <p-button class="mr-2" icon="pi pi-trash" (click)="EliminarDocumento(element.id)" styleClass="p-button-rounded p-button-danger p-button-text" ></p-button>
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
